import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center flex-wrap gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_DanhMucVatTuSearchInput = _resolveComponent("DanhMucVatTuSearchInput")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_PageHeaderFilters = _resolveComponent("PageHeaderFilters")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_DanhSachVatTuTable = _resolveComponent("DanhSachVatTuTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderFilters, null, {
        default: _withCtx(() => [
          _createVNode(_component_FilterItem, { label: "Trạng thái" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.validStatus,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.validStatus) = $event)),
                placeholder: "Trạng thái",
                clearable: "",
                onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validStatus = -1))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: status.value,
                      label: status.label,
                      value: status.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_FilterItem, { label: "Nhóm vật tư" }, {
            default: _withCtx(() => [
              _createVNode(_component_DanhMucVatTuSearchInput, {
                id: _ctx.dmVatTuId,
                "display-label": _ctx.selectedDmVatTuLabel,
                onClear: _ctx.handleDmClear,
                onSelect: _ctx.handleDmSelect
              }, null, 8, ["id", "display-label", "onClear", "onSelect"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.thuHoiFilter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.thuHoiFilter) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Thu hồi")
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.congTyDuyetFilter,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.congTyDuyetFilter) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cty duyệt")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.openPrintViewer }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faPrint }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Xem danh sách vật tư (PDF) ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_DanhSachVatTuTable, {
        "cur-page": _ctx.currentPage,
        "is-loading": _ctx.loading,
        items: _ctx.items,
        "per-page": _ctx.perPage,
        "show-approve-button": true,
        onDeleteVatTuSuccess: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fetchVatTuItems())),
        onOnApproveSuccess: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fetchVatTuItems())),
        onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchVatTuItems()))
      }, null, 8, ["cur-page", "is-loading", "items", "per-page"]),
      (_ctx.items.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": _ctx.perPage,
            total: _ctx.totalItems,
            onChangePage: _cache[7] || (_cache[7] = (value) => (_ctx.currentPage = value)),
            onChangePageSize: _cache[8] || (_cache[8] = (value) => (_ctx.perPage = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}